const services = [
  {
    icon: 'ri-temp-cold-line',
    title: 'Air Conditioning Repair & Installation',
    desc: 'Beat the heat with efficient cooling systems designed for long-term performance and lower energy costs. From central AC to ductless mini-splits.',
    tag: 'Most Requested',
    image: 'https://public.readdy.ai/ai/img_res/4afbae6d3e3967777a3e66ce03c53a19.jpg',
  },
  {
    icon: 'ri-fire-line',
    title: 'Heating Services',
    desc: 'Reliable furnace and heat pump installation, repair, and maintenance to keep your home warm all season long.',
    tag: 'Furnace & Heat Pump',
    image: 'https://readdy.ai/api/search-image?query=modern%20home%20heating%20system%20furnace%20heat%20pump%20installation%20clean%20utility%20room%20professional%20HVAC%20equipment%20warm%20lighting%20residential%20interior%20photography&width=600&height=400&seq=svc-heat-001&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: 'HVAC Maintenance',
    desc: 'Preventative maintenance to extend system lifespan, improve efficiency, and avoid costly breakdowns before they happen.',
    tag: 'Preventative Care',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20technician%20performing%20maintenance%20inspection%20on%20air%20conditioning%20unit%20rooftop%20professional%20service%20clean%20equipment%20tools%20residential%20commercial%20building%20bright%20daylight%20photography&width=600&height=400&seq=svc-maint-001&orientation=landscape',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Indoor Air Quality',
    desc: 'Advanced filtration, purification, and ventilation solutions for healthier indoor air and reduced allergens.',
    tag: 'Healthier Air',
    image: 'https://readdy.ai/api/search-image?query=clean%20fresh%20indoor%20air%20quality%20modern%20living%20room%20bright%20airy%20space%20air%20purifier%20ventilation%20system%20healthy%20home%20environment%20natural%20light%20white%20interior%20minimal%20design%20photography&width=600&height=400&seq=svc-iaq-001&orientation=landscape',
  },
  {
    icon: 'ri-building-line',
    title: 'Commercial HVAC',
    desc: 'Scalable HVAC solutions for businesses, offices, and commercial properties — designed for reliability and efficiency at any scale.',
    tag: 'Business Ready',
    image: 'https://readdy.ai/api/search-image?query=commercial%20HVAC%20rooftop%20units%20large%20office%20building%20industrial%20air%20conditioning%20system%20professional%20installation%20modern%20commercial%20property%20exterior%20photography%20clear%20sky&width=600&height=400&seq=svc-comm-001&orientation=landscape',
  },
];

export default function Services() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="bg-[#0f1923] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">What We Do</span>
            <h2
              className="text-4xl md:text-5xl font-bold text-white mt-3 leading-tight"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              HVAC Services in
              <br />
              <span className="text-[#00d4ff]">North Carolina</span>
            </h2>
          </div>
          <p className="text-[#9ca3af] text-base max-w-sm leading-relaxed">
            Over a decade of experience combined with competitive pricing — so our clients can rest easy.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((svc, idx) => (
            <div
              key={svc.title}
              className={`group relative bg-[#1a2535] rounded-2xl border border-white/5 hover:border-[#00d4ff]/30 transition-all duration-300 hover:-translate-y-1 cursor-default overflow-hidden ${idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`}
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={svc.image}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-0 left-0 right-0 h-44 bg-gradient-to-b from-transparent to-[#1a2535]/60" />
              </div>

              {/* Content */}
              <div className="p-7 relative">
                {/* Glow on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#00d4ff]/0 to-[#00d4ff]/0 group-hover:from-[#00d4ff]/3 group-hover:to-transparent transition-all duration-300 rounded-b-2xl" />

                {/* Tag */}
                <span className="inline-block bg-[#00d4ff]/10 text-[#00d4ff] text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-4">
                  {svc.tag}
                </span>

                {/* Icon */}
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#00d4ff]/10 border border-[#00d4ff]/20 mb-4 group-hover:bg-[#00d4ff]/20 transition-colors duration-200">
                  <i className={`${svc.icon} text-[#00d4ff] text-lg`} />
                </div>

                <h3 className="text-white font-bold text-lg mb-3 leading-snug" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {svc.title}
                </h3>
                <p className="text-[#9ca3af] text-sm leading-relaxed mb-5">{svc.desc}</p>

                <a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
                  className="inline-flex items-center gap-1.5 text-[#00d4ff] text-sm font-semibold hover:gap-3 transition-all duration-200 cursor-pointer"
                >
                  Get a Quote
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm" />
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="inline-block bg-[#00d4ff] hover:bg-[#00b8d9] text-[#0a1628] font-bold text-base px-10 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Get a Quote Today
          </a>
        </div>
      </div>
    </section>
  );
}
